import footerStyles from "../footer/footer.module.css";

export default function Footer() {
  return (
    <div className={footerStyles.footer}>
      <h5 className={footerStyles.title}>
        This app is fully designed and created by .Caster 2023
      </h5>
    </div>
  );
}
